import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	input,
} from '@angular/core';

@Component({
	standalone: true,
	selector: 'mar-card-grid',
	styleUrl: 'card-grid.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `<ng-content />`,
})
export class CardGridComponent {
	readonly size = input<'s' | 'm' | 'xs'>('m');
	readonly columns = input<3 | undefined>();

	@HostBinding('attr.size')
	get attrSize() {
		return this.size();
	}

	@HostBinding('attr.columns')
	get attrColumns() {
		return this.columns() ?? null;
	}
}
